// App logo — renders the favicon SVG inline for crisp display at any size

interface LogoProps {
  size?: number;
  className?: string;
}

/** Inline SVG logo — document with checkmark in emerald accent */
export function Logo({ size = 32, className }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      {/* Background circle */}
      <circle cx="32" cy="32" r="32" fill="#0f172a" />
      {/* Document shape */}
      <path
        d="M20 12h16l10 10v30a2 2 0 0 1-2 2H20a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2z"
        fill="#1e293b"
        stroke="#10b981"
        strokeWidth="1.5"
      />
      {/* Folded corner */}
      <path
        d="M36 12v10h10"
        fill="#1e293b"
        stroke="#10b981"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Text lines */}
      <rect x="24" y="30" width="16" height="2" rx="1" fill="#10b981" opacity="0.7" />
      <rect x="24" y="36" width="12" height="2" rx="1" fill="#10b981" opacity="0.5" />
      <rect x="24" y="42" width="14" height="2" rx="1" fill="#10b981" opacity="0.3" />
      {/* Checkmark circle */}
      <circle cx="44" cy="44" r="10" fill="#10b981" />
      <path
        d="M39 44l3 3 6-6"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
